import { TertiaryIconButton } from './Buttons/IconButton'
import OutsideAlerter from '../../utils/OutsideAlerter'
import { useEffect, useRef, useState } from 'react'

const Modal = ({
  type,
  children,
  closeModal,
  header,
  hasCloseButton,
  icon,
  subTitle,
  title,
  customHeader,
  centeredHeader,
  success
}) => {
  const contentRef = useRef(null)
  const [scrollHeight, setScrollHeight] = useState(false)
  const [active, setActive] = useState(false)

  useEffect(() => {
    setActive(true)
  }, [])

  useEffect(() => {
    setScrollHeight(contentRef.current?.scrollHeight)
  }, [children])

  const widths = {
    large: 'lg:w-[1247px]',
    medium: 'lg:w-[840px]',
    semiMedium: 'lg:w-[620px]',
    small: 'lg:w-[500px]',
  }
  return (
    <div
      id='defaultModal'
      tabIndex='-1'
      aria-hidden='true'
      className='overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full h-full md:inset-0 h-modal min-h-[100] max-h-[100vh] flex items-center justify-center'
    >
      <div
        className='fixed top-0 left-0 w-full h-full bg-gray-600/40'
        onClick={closeModal}
      />
      <div className='relative px-24 py-32 h-full overflow-hidden max-h-[750px] pointer-events-none'>
        <div
          className={
            widths[type] +
            ' mx-auto h-full lg:min-w-[500px] w-80% pointer-events-auto '
          }
        >
          <div
            className={
              'relative bg-white rounded-8 shadow transition-all duration-200 m-auto max-w-[1400px] max-h-[100%] flex flex-col overflow-auto ' +
              (active ? 'opacity-1' : 'opacity-0')
            }
          >
            <div
              ref={contentRef}
              className={' flex flex-col flex-grow min-h-[0]'}
            >
              {icon || title || subTitle || hasCloseButton || customHeader ? (
                <div className={'flex p-24 pb-0 items-center'}>
                  {centeredHeader ? (
                    <div className='min-w-[36px] h-[36px] mr-auto' />
                  ) : null}
                  {customHeader ? (
                    customHeader()
                  ) : (
                    <div
                      className={
                        'flex items-center ' +
                        (centeredHeader
                          ? 'flex-col justify-center space-y-16'
                          : 'space-x-16')
                      }
                    >
                      {icon ? (
                        <div
                          className={
                            'rounded-full flex items-center justify-center ' +
                            (centeredHeader
                              ? 'min-w-[40px] h-40 text-2xl'
                              : 'min-w-[32px] h-32') + (success ? ' bg-backgroundSuccess text-success' : ' bg-primaryLight3 text-primary')
                          }
                        >
                          <i className={icon} />
                        </div>
                      ) : null}
                      {title || subTitle ? (
                        <div
                          className={
                            'space-y-8 mr-16 ' +
                            (centeredHeader ? 'text-center' : '')
                          }
                        >
                          {title ? (
                            <h3 className='font-bold text-[17px] leading-[21px]'>
                              {title}
                            </h3>
                          ) : null}
                          {subTitle ? (
                            <span className='text-greyLight2 text-sm block leading-[17px]'>
                              {subTitle}
                            </span>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  )}
                  {hasCloseButton ? (
                    <button
                      onClick={closeModal}
                      className='self-start rounded-full text-xl bg-backgroundPrimary text-greyLight2 min-w-[36px] h-[36px] ml-auto flex items-center justify-center transition-colors duration-200 hover:bg-primaryLight3 hover:text-primary'
                    >
                      <i className='icon-close' />
                    </button>
                  ) : null}
                </div>
              ) : null}
              <div className={' flex-grow min-h-[0] flex flex-col '}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Modal.defaultProps = {
  type: 'large',
  header: false,
  hasCloseButton: true,
}

export default Modal
